import { Grid } from "@mui/material";
import useLocales from "src/hooks/useLocales";
import { PATH_LINK } from "src/utils/paths";

import DemoItemCard from "./DemoItemCard";

// ----------------------------------------------------------------------

export const DemoServiceGrid = () => {
	const { translate } = useLocales();

	return (
		<Grid sx={{ px: { xl: 40, lg: 30, md: 12, sm: 10, xs: 6 }, mt: 10 }} gap={4} container>
			<Grid item>
				<DemoItemCard
					ilPath='/ilustrations/data-extraction-amico.svg'
					navPath={PATH_LINK.demo.positions}
					title={translate("demo.positions")}
					description={translate("demo.positions_des")}
				/>
			</Grid>
			<Grid item>
				<DemoItemCard
					ilPath='/ilustrations/data-extraction-pana.svg'
					navPath={PATH_LINK.demo.transactions}
					title={translate("demo.transactions")}
					disabled
					description={translate("demo.transactions_des")}
				/>
			</Grid>
		</Grid>
	);
};

export default DemoServiceGrid;
